const mEditionBillingMySalesInvoicesHistoryDropDownFilters = {
  mEditionBillingMySalesInvoicesHistoryDropDownFilters: {
    buttonPrimary: 'FILTRAR',

    buttonSecondary: {
      restartText: 'ACTUALIZAR'
    },

    input: {
      divisa: {
        label: 'Monedas'
      },

      estado: {
        label: 'Estados de Comprobante'
      },

      fechaDesde: {
        label: 'Fecha Desde',
        placeholder: 'Desde - DD MM, AAAA'
      },

      fechaHasta: {
        label: 'Fecha Hasta',
        placeholder: 'Hasta - DD MM, AAAA'
      },

      pais: {
        label: 'País',
        firstOption: 'Todos los países'
      }
    }
  }
}

export default mEditionBillingMySalesInvoicesHistoryDropDownFilters
